import WishCard from './WishCard';
import type { ApiWish, Wish } from '../../types';
import './WishCardList.css';

interface WishCardListProps {
  wishes: (Wish | ApiWish)[];
  loading?: boolean;
  onWishClick?: (wishId: string) => void;
}

const WishCardList = ({ wishes, loading, onWishClick }: WishCardListProps) => {
  if (loading) {
    return (
      <div className="wish-card-list">
        <div className="wish-card-list__loading">載入中...</div>
      </div>
    );
  }

  if (wishes.length === 0) {
    return (
      <div className="wish-card-list">
        <div className="wish-card-list__empty">
          <h3>找不到許願</h3>
          <p>試試調整篩選條件</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wish-card-list">
      {wishes.map((wish) => (
        <WishCard key={wish.id} wish={wish} onClick={onWishClick} />
      ))}
    </div>
  );
};

export default WishCardList;
